import React, { useEffect, useState } from 'react';
import swal from 'sweetalert';

const Allorder = () => {

    const [all, setAll] = useState([])
    const [loading, setLoading] = useState(true)
console.log(all);
    useEffect(() => {
        const url = `https://infinite-peak-44533.herokuapp.com/allorderplace`
        fetch(url)
            .then(res => res.json())
            .then(data => setAll(data))
        setLoading(false)
    }, [])
    console.log(all);
    if (loading) {
        <div>
            <h1 className='display-6'>Loading...</h1>
        </div>
    }
    const handleDeleted = (id) => {
        const procces = window.confirm('Are You Sure, You Want To Delet')
        if (procces) {
            fetch(`https://infinite-peak-44533.herokuapp.com/allorderplace/${id}`, {
                method: 'DELETE',
                headers: {
                    'content-type': 'application/json'
                }
            })
                .then(res => res.json())
                .then(data => {
                    if (data.deletedCount >= 0) {
                        swal("Delete successfully");
                        const rstrongainignData = all.filter(x => x._id !== id)
                        setAll(rstrongainignData)
                    }

                })
        }

    }
    return (

        <div className='my-5'>
            {all.map((menuItem) => {
                const { email, productName, image, price, phone, _id, name, city } = menuItem;
                return (
                    <article

                        data-aos="fade-up"
                        data-aos-anchor-placement="bottom-bottom"

                        className='menu-item'>
                        <img src={image} alt={name} className='photo' />
                        <div className='item-info'>
                            <header>

                                <h4>{name}</h4>

                                <h4 className='price'>${city}</h4>
                            </header>
                            <h4 className='price'>Food Name:  {productName}</h4>
                            <h4 className='price'>Price:  {price}</h4>

                            <p className='item-text'>{phone}</p>
                            <p className='item-text'>{email} </p>
                            <div className='text-start my-3'>

                             
                                <button onClick={() => handleDeleted(_id)} style={{ backgroundColor: '#e62143' }} className='button-8 m-0 px-5 text-white ms-3'>Delete</button>

                            </div>
                        </div>
                    </article>
                );
            })}
        </div>
    );
};

export default Allorder;